import { Navigate, Route, Routes } from 'react-router-dom';
import App from 'src/components/App';
import {
    BULK_GRANULAR_SLA_MANAGEMENT_PATH,
    GRANULAR_SLA_LANDING_PATH,
    GRANULAR_SLA_MANAGEMENT_PATH,
    ROOT_PATH,
    R2F_THRESHOLD_CONFIG_PATH,
    R2F_THRESHOLD_CONFIG_WITH_SITE_PATH,
    BULK_R2F_THRESHOLD_CONFIG_PATH,
    CORA_PATH,
    CORA_WITH_NODE_PATH,
    FC_CONFIG_PATH,
    TRB_PATH,
    TRB_WITH_REGION_PATH,
    SHIPMENT_HISTORY_PATH,
    SHIPMENT_HISTORY_WITH_ID_PATH,
} from 'src/core/config/navigationRoutes';
import BulkProductionCapabilityManager from 'src/features/pages/granularSLA/BulkProductionCapabilityManager';
import GranularSLALandingPage from 'src/features/pages/granularSLA/GranularSLALandingPage';
import ProductionCapabilityManagerWithHierarchy from 'src/features/pages/granularSLA/ProductionCapabilityManagerWithHierarchy';
import LandingPage from 'src/features/pages/LandingPage';
import R2FThresholdManager from 'src/features/pages/r2fThresholds/R2FThresholdManager';
import BulkR2FManager from 'src/features/pages/r2fThresholds/BulkR2FManager';
import CORAPage from 'src/features/pages/cora/CORAPage';
import FCConfigPage from 'src/features/pages/fcconfig/FCConfigPage';
import TRBPage from 'src/features/pages/trb/TRBPage';
import SafeShipmentUpdatesPage from 'src/features/components/shipmentUpdates/SafeShipmentUpdatesPage';
import { isAFTXCustomer } from 'src/utils/aftxDetection';

/**
 * ApplicationRoutes - Main routing component that handles both regular and AFTX customers.
 * Both use the same App layout — the nav bar is automatically hidden on CORA pages.
 *
 * AFTX customers are restricted to CORA routes only and are redirected from / to /cora.
 * Regular customers have access to all features.
 */
const ApplicationRoutes = () => {
    const isAFTX = isAFTXCustomer();

    if ( isAFTX )
    {
        // AFTX customers: restricted to CORA functionality only
        // Redirects / to /cora so the nav-hiding logic in App works consistently
        return (
            <Routes>
                <Route path={ROOT_PATH} element={<App />}>
                    <Route index element={<Navigate to={CORA_PATH} replace />} />
                    <Route path={CORA_PATH} element={<CORAPage />} />
                    <Route path={CORA_WITH_NODE_PATH} element={<CORAPage />} />
                </Route>
            </Routes>
        );
    }

    // Regular customers: full Newton Dashboard functionality
    return (
        <Routes>
            <Route path={ROOT_PATH} element={<App />}>
                <Route index element={<LandingPage />} />
                <Route path={GRANULAR_SLA_LANDING_PATH} element={<GranularSLALandingPage />}> </Route>
                <Route path={GRANULAR_SLA_MANAGEMENT_PATH} element={<ProductionCapabilityManagerWithHierarchy />} />
                <Route path={BULK_GRANULAR_SLA_MANAGEMENT_PATH} element={<BulkProductionCapabilityManager />} />
                <Route path={R2F_THRESHOLD_CONFIG_PATH} element={<R2FThresholdManager />} />
                <Route path={R2F_THRESHOLD_CONFIG_WITH_SITE_PATH} element={<R2FThresholdManager />} />
                <Route path={BULK_R2F_THRESHOLD_CONFIG_PATH} element={<BulkR2FManager />} />
                <Route path={CORA_PATH} element={<CORAPage />} />
                <Route path={CORA_WITH_NODE_PATH} element={<CORAPage />} />
                <Route path={FC_CONFIG_PATH} element={<FCConfigPage />} />
                <Route path={TRB_PATH} element={<TRBPage />} />
                <Route path={TRB_WITH_REGION_PATH} element={<TRBPage />} />
                <Route path={SHIPMENT_HISTORY_PATH} element={<SafeShipmentUpdatesPage />} />
                <Route path={SHIPMENT_HISTORY_WITH_ID_PATH} element={<SafeShipmentUpdatesPage />} />
            </Route>
        </Routes>
    );
};

export default ApplicationRoutes;
